// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing_Careers_section {\n    width: 60%;\n    margin: auto;\n    padding-top: 40px;\n    color: #867D77;\n}\n\n\n.landing_Careers_section p {\n    text-align: center;\n}\n\n\n\n\n@media(min-width: 1600px) {\n\n    .landing_Careers_section{\n\t\tmin-height: 457px;\n        width: 60%;\n        margin: auto;\n        padding-top: 150px;\n        color: #867D77;\n\t}\n\n}", ""]);
// Exports
module.exports = exports;
